import React from 'react';
import './Loader.css'; // Import CSS file for the loader styles

const Loader = () => (
    <center>
      <span className="loader" />
    </center>
  );

export default Loader;
